import { axiosPost } from '../../axios/axios.config';
import { LoginData } from './model'

export const LoginUser = (data: LoginData) => {
  return axiosPost("/jwt-auth/v1/token", data);
}